"use client";

import { EdgenModalCreateAble } from "@/src/components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@/src/components/EdgenModal/waitForEdgenModalRoot";
import { DIAGNOSIS_UNLOCK_MODAL_PROPS } from "./diagnosisUnlockModalShell";
import { DiagnosisUnlockFlowContent } from "./DiagnosisUnlockFlowContent";
import type {
  DiagnosisUnlockFlowResult,
  OpenDiagnosisUnlockModalParams,
} from "./types";

let pendingDiagnosisUnlockModal: Promise<DiagnosisUnlockFlowResult> | null =
  null;

function resolveFetchGoalDetail(
  params: OpenDiagnosisUnlockModalParams,
): boolean {
  return params.fetchGoalDetail !== false;
}

/**
 * 理财诊断 → 解锁三步弹窗 **唯一入口**。
 *
 * 详见 `DiagnosisUnlockFlow/README.md`。
 */
export const openDiagnosisUnlockModal = (
  params: OpenDiagnosisUnlockModalParams,
): Promise<DiagnosisUnlockFlowResult> => {
  if (pendingDiagnosisUnlockModal) {
    return pendingDiagnosisUnlockModal;
  }

  const fetchGoalDetail = resolveFetchGoalDetail(params);
  const initialStep = params.initialStep ?? "step1";

  if (fetchGoalDetail && !params.goalId) {
    return Promise.reject(
      new Error("openDiagnosisUnlockModal: goalId is required when fetching"),
    );
  }

  if (!fetchGoalDetail && !params.payload) {
    return Promise.reject(
      new Error(
        "openDiagnosisUnlockModal: payload is required when fetchGoalDetail is false",
      ),
    );
  }

  pendingDiagnosisUnlockModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<DiagnosisUnlockFlowResult>((resolve) => {
        let settled = false;

        const finish = (result: DiagnosisUnlockFlowResult) => {
          if (settled) {
            return;
          }
          settled = true;
          pendingDiagnosisUnlockModal = null;

          params.onComplete?.(result);
          EdgenModalCreateAble.end(false);
          resolve(result);
        };

        EdgenModalCreateAble.call({
          children: (
            <DiagnosisUnlockFlowContent
              fetchGoalDetail={fetchGoalDetail}
              goalId={fetchGoalDetail ? params.goalId : undefined}
              payload={fetchGoalDetail ? undefined : params.payload}
              initialStep={initialStep}
              chrome={params.chrome}
              step1BackgroundSrc={params.step1BackgroundSrc}
              hideActionSummarySection={params.hideActionSummarySection}
              onFinish={finish}
            />
          ),
          ...DIAGNOSIS_UNLOCK_MODAL_PROPS,
        });
      }),
  ).catch((error) => {
    pendingDiagnosisUnlockModal = null;
    throw error;
  });

  return pendingDiagnosisUnlockModal;
};
